import React from "react";
import { Link, useParams } from "react-router-dom";

function EnergyBreadCrumb() {
  const { plantName } = useParams();

  // Decode slug
  const decodedPlantName = plantName.replace(/-/g, " ");

  // Convert to TITLE CASE (recommended)
  const formattedPlantName = decodedPlantName.replace(
    /\b\w/g,
    (char) => char.toUpperCase()
  );

  // OR if you want FULL UPPERCASE
  // const formattedPlantName = decodedPlantName.toUpperCase();

  return (
    <div className="breadcrumb-wrapper py-3 px-3">
      <div className="container">
        <h2 className="breadcrumb-title mb-2">
          {formattedPlantName}
        </h2>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb custom-breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to="/" className="breadcrumb-link">Home</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/renewableenergyindia" className="breadcrumb-link">
               Renewable Energy in India
              </Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {formattedPlantName}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
}

export default EnergyBreadCrumb;
